export default {
  saveSuccessMsg: 'Save Successfully!',
  changeLanguageTips: 'Switching language succeeded',
  modifyPwdSuccess: 'Password changed successfully',
  noFileMsgOrError: 'No file information or file error',
  immutableInfo: 'The student information cannot be modified',
  unknownError: 'unknownError, please contact the administrator!',
  expired: 'authentication has expired',
  deleteSuccess: 'Deleted successfully',
  addSuccess: 'Added successfully',
  editSuccess: 'Edit successfully',
  setSuccess: 'Set successfully',
  removeSuccess: 'Removed successfully',
  removeSuperiorConfirm: 'Are you sure you want to remove the checked business supervisor for {name}? ',
  appendSuperiorConfirm: 'Are you sure you want to set the checked person as the business supervisor of {name}',
  uploadLimit: "The uploaded file can only be in PDF format!",
  uploadSize: "The uploaded file cannot exceed {limit}M!",
  uploadFail: "Upload Failed",
  delMsgFile: "Are you sure you want to delete this File?",
  deleteSucc: "Delete successfully",
  deleteFail: "Delete failed",
  differentialSubmissionConfirm: "Are you sure you want to submit your current statement by 'Submit for difference'?",
  differentialSubmissionConfirm2: 'Please check the option that you want to differentially submit your current bill!',
  differentialSubmissionSuccess: "submit successfully!",
  pleaseSelectAllUnsettledPayBackStatement: 'please check all negative statement first, then click submit.',
  unsettledPayBackStatementMessage:'Negative bill difference submitted for review, can not submit settlement!',
  pleaseSelectBankInfo: 'Please select your bank information!',
  pleaseSelectSettleMethod: 'Please select settlement approach!',
  pleaseCompleteSettleInfo: 'Please fill in settlement currency!',
  pleaseCompleteOriginalCurrency: 'Please fill in Original Currency!',
  uploadFileTips: 'Only PDF files are supported, please re-upload files that meet the format requirements!',
  submitAndDownloadSuccess: 'Submit and download successfully!',
  downloadSuccess: 'Download successfully!',
  pleaseSelectSettledMessage: 'Please check you need to settle the commission!',
  businessOverviewMessage: 'Please select the year first!',
  selectInstitutionMessage: 'The name of the institution and the country of application are linked, please select the country of application ',
}
